var React = require('react');

function LogoGrey (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m137.6 55.7c-4.3 0-7.9-3.5-7.9-7.9s3.5-7.9 7.9-7.9 7.9 3.5 7.9 7.9-3.6 7.9-7.9 7.9zm32.6-7.8c0-4.3-3.5-7.9-7.9-7.9s-7.9 3.5-7.9 7.9 3.5 7.9 7.9 7.9c4.4-.1 7.9-3.6 7.9-7.9zm16.9 41.6c-4.3 0-7.9 3.5-7.9 7.9s3.5 7.9 7.9 7.9c4.3 0 7.9-3.5 7.9-7.9s-3.6-7.9-7.9-7.9zm0-49.5c-4.3 0-7.9 3.5-7.9 7.9s3.5 7.9 7.9 7.9c4.3 0 7.9-3.5 7.9-7.9-.1-4.4-3.6-7.9-7.9-7.9zm0 24.8c-4.3 0-7.9 3.5-7.9 7.9 0 4.3 3.5 7.9 7.9 7.9 4.3 0 7.9-3.5 7.9-7.9-.1-4.4-3.6-7.9-7.9-7.9zm-66.4 49.5v-74.3h-15.7v90h89.9v-15.7z","fill":"#75787b"}));
}

LogoGrey.defaultProps = {"viewBox":"100 35 100 100"};

module.exports = LogoGrey;

LogoGrey.default = LogoGrey;
